const shouldBlockPath = ({ denyList, path }: { denyList: Array<string | RegExp>; path: string }): boolean => {
  return denyList.some((pattern) => {
    if (typeof pattern === 'string') {
      // For exact paths, check for an exact match
      return path === pattern;
    } else {
      // For patterns, test the path against the regex
      return pattern.test(path);
    }
  });
};

export default shouldBlockPath;
